import { ShippingProviders } from 'domains/shippingProviders'

import { protectedApi } from './requester'

export const getShippingProviders = async () => {
  return protectedApi
    .get<ShippingProviders[]>('/shippingProviders')
    .then((response) => response.data)
}
